export default "__VITE_ASSET__BqPwltw___"